import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { hc, type InferResponseType } from 'hono/client'
import type { DashboardApi } from '@backend/api/stores/DashboardStore'
import { apiFetch } from '@paraflow-ai/frontend-libs'

type Store = ReturnType<typeof createStore>
const api = hc<DashboardApi>('/api/stores/dashboard', { fetch: apiFetch })

type DashboardState = InferResponseType<typeof api.refresh.$get, 200>

export const refreshAtom = atomWithQuery(() => ({
  queryKey: ['DashboardStore'],
  queryFn: async () => {
    const res = await api.refresh.$get()
    return await res.json()
  },
}))

export function loader(store: Store) {
  store.get(refreshAtom)
  return null
}
